import axios from 'axios'

export default function (context, val) {
  let item = context.state.items.filter(i => {
    return i.WebReportId === val;
  })[0];
  if (!item) return;
  let selection = context.rootGetters['subsidies/item/form/data'];

  let url = '';
  if (item.NeedScreenFilter) {
    url = item.Url;
    let form = rootGetters['subsidies/item/form/data'];
    for (let k in form) {
      switch (k) {
        case 'StartDate':
        case 'EndDate':
        case 'IssueDate':
          url += '&' + encodeURIComponent('parameters[' + k + '.Serialized]') + '=' + encodeURIComponent(form[k].Serialized);
          break;
        default:
          url += '&' + encodeURIComponent('parameters[' + k + ']') + '=' + encodeURIComponent(form[k]);
      }
    }
    if (item.ReportFormat == 'html') {

      let paramsForPrint = url.replace(/parameters\[/g, '').replace(/\]/g, '');
      paramsForPrint = paramsForPrint.substr(paramsForPrint.indexOf('?') + 1);
      url = '/tourclient/editor/#/print/' + item.WebReportId + '?' + paramsForPrint;
    }
    window.open(url);
    return;
  }
  url = '/tourclient/report/getReportFilterFields?';
  url += '&ReportID=' + item.Id;
  url += '&ReportTemplateID=' + item.TemplateId;
  url += '&WebReportId=' + item.WebReportId;
  if (item.NeedSelectedData && item.NeedSelectedData.length) {
    let a = '';
    item.NeedSelectedData.forEach(i => {
      a = encodeURIComponent(i + '=' + selection[i]);
    });
    url += '&SelectedData=' + a;
  }
  axios({
    method: 'get',
    url,
  }).then(({data}) => {
    if (data.Fields && data.Fields.length) {
      item.fields = data.Fields;
      window.app.$dialog('reports', {
        item: item,
        change: val => {
          context.dispatch('open', item);
        },
      })
    } else {
      context.dispatch('open', item);
    }
  }).catch(e => {
    context.dispatch('error', e, {root: true});
  });
}
